var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.91 101.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed8ce8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logistic-package") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.94,43.51l4.77-.13q.06-2.23.11-4.46c-1,1-2,1.92-3,2.84C42.22,42.36,41.58,43,40.94,43.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.88,43.65h4c1.22-1.22,2.6-2.3,3.86-3.45s2.73-2.51,4.12-3.74q0-2.6.06-5.2c-2.19,2.39-4.41,4.75-6.68,7A66,66,0,0,1,33.88,43.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.8,70.88c4.14,0,8.26.12,12.39.4-1.71-4.4-4-8.65-5.91-13C34.9,62.35,32.89,66.7,30.8,70.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.8,27.05c-4.86,4.24-9,9.73-14.07,13.69,0,.94,0,1.89,0,2.83h1.84c5.6-4.42,10.53-10,15.33-15.3q0-.57,0-1.13C44.88,27.14,43.8,27.09,42.8,27.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.42,27.15q.1,2.22.16,4.44c1.79-1.65,3.73-3.16,5.66-4.61Q31.33,27,28.42,27.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.14,27V27c-3,2.37-5.62,5.09-8.46,7.57v2.94C32.39,33.94,35.94,30.05,40,27,39.07,27,38.11,27,37.14,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.59,27.08A11.84,11.84,0,0,0,67.9,27a9.55,9.55,0,0,0-3.15.73c-2.94,1.53-5.13,3.45-5,7.91s3.15,8.16,7.91,7.86a8.16,8.16,0,0,0,7.9-7.44,10.2,10.2,0,0,0-1.44-5.54A7.67,7.67,0,0,0,69.59,27.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.5.1C33.16-1.54,0,16.59,0,50.1s30.3,49.37,49.5,50.8c23.5,1.75,48.75-13.25,53-46C106.3,25.67,82.8,1.94,56.5.1Zm-10,76.11a160,160,0,0,0-19.63-.62,2.37,2.37,0,0,1-2-3.53c2-3.69,4.13-7.33,6.21-11,1.64-2.89,3.1-6.12,5.3-8.64,1.1-1.26,3-.31,3.3,1a2,2,0,0,1,.3.4c2,3.51,3.59,7.33,5.24,11a61.85,61.85,0,0,1,3.58,8.43c.34,1.33-.74,3.13-2.27,3Zm3.58-30.62a2.27,2.27,0,0,1-2.23,2.23c-7,.12-14.19.49-21.22,0a2.2,2.2,0,0,1-2.15-2.15c0-6.38-.11-12.79.35-19.15a2,2,0,0,1,.14-.59,2.25,2.25,0,0,1,2-3c7.06-.37,14.09-.15,21.15,0a2.23,2.23,0,0,1,2.19,2.19c.25,6.8,0,13.65-.21,20.46ZM78.63,67a31.77,31.77,0,0,1-7.83,7.48c-2.25,1.59-4,2.29-6.33.65C61.36,73,57.38,69.33,55.56,66c-2.07-3.83,2.63-8.55,6.82-11.56a13.58,13.58,0,0,1,2.94-2.31c4.07-2.72,10.2,5,12.53,8,1.73,2.27,2.48,4.41.8,6.92ZM67.88,48c-16.58.38-15.72-25.72-1-25.64h.15c7.6-1.17,13.06,6.46,13.15,13.41S74.55,47.88,67.9,48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.342aa6a7e877c2dda7b2673bb437e571.svg";
export { ForwardRef as ReactComponent };